import React, { Fragment } from "react";
import { Container, Divider, Box } from "@material-ui/core";

export class StepperContent extends React.Component {
  render() {
    return (
      <Fragment>
        <Container maxWidth={false}>
          <Box sx={{ marginBottom: "2.5rem" }}>{this.props.children}</Box>
          <Divider />
        </Container>
      </Fragment>
    );
  }
}
